import script from "./GroupPurchaseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupPurchaseDetail.vue?vue&type=script&setup=true&lang=js"

import "./GroupPurchaseDetail.vue?vue&type=style&index=0&id=9ee7f8f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ee7f8f6"]])

export default __exports__